import type { Language } from "@clovis/server/src/app/config/i18next/languages/allowed-languages";
import { TranslateIcon } from "@heroicons/react/outline";
import React from "react";
import { Button } from "~/design-system/Button";
import {
  DropdownMenu,
  DropdownMenuContent,
  MenuItem,
} from "~/design-system/DropdownMenu";
import { useBreakpoint } from "~/design-system/hooks";
import { Text } from "~/design-system/Text";

const LANGUAGES_ = {
  de: "Deutsch",
  en: "English",
  es: "Español",
  fr: "Français",
  nl: "Nederlands",
  pt: "Português",
};

type LanguageType = `${Language}`;

type LanguageDropdownProps = {
  language: LanguageType;
  setLanguage: React.Dispatch<LanguageType>;
  showTextOnMobile?: boolean;
  size?: "small" | "standard";
};

function LanguageDropdown(props: LanguageDropdownProps) {
  const { breakpoint } = useBreakpoint();
  const isMobile = breakpoint === "mobile";
  const showText = isMobile ? props.showTextOnMobile ?? true : true;
  const buttonSize = props.size ?? (isMobile ? "small" : "standard");

  return (
    <DropdownMenu
      label="language options"
      trigger={
        <Button
          size={buttonSize}
          variant="ghost"
          leadingIcon={<TranslateIcon />}
          dataClovisActionId="rights-language-dropdown"
          css={{
            height: buttonSize === "small" ? "38px" : "42px",
            minHeight: buttonSize === "small" ? "38px" : "42px",
          }}
        >
          {showText ? LANGUAGES_[props.language] : undefined}
        </Button>
      }
    >
      <DropdownMenuContent>
        <MenuItem onClick={() => props.setLanguage("en")}>
          <Text>English</Text>
        </MenuItem>
        <MenuItem onClick={() => props.setLanguage("fr")}>
          <Text>Français</Text>
        </MenuItem>
        <MenuItem onClick={() => props.setLanguage("de")}>
          <Text>Deutsch</Text>
        </MenuItem>
        <MenuItem onClick={() => props.setLanguage("es")}>
          <Text>Español</Text>
        </MenuItem>
        <MenuItem onClick={() => props.setLanguage("nl")}>
          <Text>Netherlands</Text>
        </MenuItem>
        <MenuItem onClick={() => props.setLanguage("pt")}>
          <Text>Português</Text>
        </MenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export type { LanguageDropdownProps, LanguageType };
export { LanguageDropdown };
